import React from "react";
import {  Label, Button } from "semantic-ui-react";

import { countries } from "../../../countries";
import { currency as currencyList } from "../../Filters/data";
import FormField from "./FormField";

function EditBankAccount({
  bankname,
  currency,
  accountNr,
  bankCode,
  IBAN,
  addressCity,
  addressCountry,
  i,
  bankAccountId,
  bclientId,
  // removeBankAccount,
  // updateBankAccount,
  handleUpdateWithType,
  updateBusinessClientBankAccount,
  ...props
}) {
  const countriesOptions = countries.map((country, i) => ({
    key: i,
    value: country,
    text: country,
  }));

  const currencyOptions = currencyList.map((currency) => ({
    key: currency,
    value: currency,
    text: currency,
  }));

  const handleUpdate = (name, value) =>
    updateBusinessClientBankAccount({
      bclientId,
      accountId: bankAccountId,
      updatedBankAccount: {
        bankname,
        currency,
        accountNr,
        bankCode,
        addressCity,
        addressCountry,
        IBAN,
        [name]: value,
      },
    });

  return (
    <div className="list-item">
      <div className="list-item__label">
        <Label
          size="small"
          circular
          content={i + 1}
          style={{ display: "inline-block" }}
        />
        <br />
        <Button
          compact
          circular
          basic
          className="list-item__delete-btn"
          size="small"
          icon="trash"
          onClick={() =>
            handleUpdateWithType({
              query: bankAccountId,
              type: "remove bank account",
            })
          }
        />
      </div>

      <div className="view-grid">
        <FormField
          label="Bank Name"
          name="bankname"
          placeholder="bank name ..."
          value={bankname}
          handleChange={handleUpdate}
        />

        <FormField
          label="Country"
          name="addressCountry"
          placeholder="country ..."
          value={addressCountry}
          handleChange={handleUpdate}
          options={countriesOptions}
        />

        <FormField
          label="City"
          name="addressCity"
          placeholder="city ..."
          value={addressCity}
          handleChange={handleUpdate}
        />

        <FormField
          label="Currency"
          name="currency"
          placeholder="currency ..."
          value={currency}
          handleChange={handleUpdate}
          options={currencyOptions}
        />

        <FormField
          label="Account Nr"
          name="accountNr"
          placeholder="account Nr ..."
          value={accountNr}
          handleChange={handleUpdate}
        />

        <FormField
          label="Bank Code"
          name="bankCode"
          placeholder="bank code ..."
          value={bankCode}
          handleChange={handleUpdate}
        />

        <FormField
          label="IBAN"
          name="IBAN"
          placeholder="IBAN ..."
          value={IBAN}
          handleChange={handleUpdate}
        />
      </div>
      {/* <Divider /> */}
    </div>
  );
}

export default EditBankAccount;
